var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSamoa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#cb2e40",
    d: "M0 0h30v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0c267b",
    d: "M0 0h15v12H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m8.34 9.63-.36-1.1-.35 1.1H6.47l.93.68-.35 1.1.93-.68.94.68-.36-1.1.94-.68zM4.94 5l-.3-.88-.28.88h-.93l.75.55-.28.88.75-.55.75.55-.29-.88.75-.55zm2.58-2.18-.29.88.75-.55.75.55-.28-.88.75-.55h-.93l-.29-.88-.28.88h-.93zM11.82 5l.71-.5h-.87l-.27-.83-.26.82h-.87l.7.51-.27.83.7-.51.7.5zM9.84 7.03l-.18-.55-.18.55H8.9l.47.34-.18.55.47-.34.47.34-.18-.55.47-.34z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSamoa);
export default __webpack_public_path__ + "static/media/samoa.ec4577939764197b08dfe81ce1e37a12.svg";
export { ForwardRef as ReactComponent };